import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './styles/Footer.css';

export default function Footer() {
  const { language } = useLanguage();
  const currentYear = new Date().getFullYear();

  const rightsText = language === 'ar' ? 'جميع الحقوق محفوظة' : 'All rights reserved.';

  return (
    <footer className="blog-footer">
      <div className="footer-line" dir="ltr">
        <span>© {currentYear} Pink Lavender Studio</span>
        <span className="separator">|</span>
        <span className="rights">{rightsText}</span>
        <span className="separator">|</span>
        <span>Crafted by Aishense ♡</span>
      </div>
    </footer>
  );
}